import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const EducationSignUpReader = (props) => <AuthPageReader {...props} domainType="EDUCATION" pageKey="signUp" />;

export default EducationSignUpReader;
